import { ILineChartLine, ILineChartSettings } from './lineChart.types'

const generateEmptyLine = (): ILineChartLine => {
  return { deviceId: null, color: '#22E303', parameterId: null }
}

const generateEmptyChartSettings = (): ILineChartSettings => {
  return {
    lines: [generateEmptyLine()],
    title: '',
    lineMode: 'step',
  }
}

const lineChartUtils = { generateEmptyChartSettings, generateEmptyLine }
export default lineChartUtils
